import { twMerge } from 'tailwind-merge';

interface SmallInfoContentProps {
  label: string;
  value: string;
  labelClassName?: string;
}

export const SmallInfoContent = ({
  label,
  value,
  labelClassName,
}: SmallInfoContentProps) => {
  return (
    <div className="leading-tight">
      <span className="inline space-x-1">
        <i className="relative top-[1.5px] ki-duotone ki-abstract-45 text-[15px] text-purple-A713F6" />
        <span
          className={twMerge(
            'font-medium text-[13.3px] text-gray-600',
            labelClassName,
          )}
        >
          {label} :
        </span>
      </span>
      &nbsp;
      <span className="text-[12.5px]">{value}</span>
    </div>
  );
};
